<!-- A dialog header with ComfyOrg logo -->
<template>
  <div class="px-2 py-4">
    <img
      src="/assets/images/comfy-logo-single.svg"
      alt="ComfyOrg Logo"
      width="32"
      height="32"
    />
  </div>
</template>
